import { cn } from '@/lib/utils'

interface BrandSignatureProps {
  /** Posicionamento fica com quem usa: a home ancora no rodapé, o login não. */
  className?: string
}

/**
 * Assinatura "Desenvolvido por DsTorres Tecnologia".
 *
 * Só em telas de ENTRADA (login, home de canais) — nunca nas telas de trabalho,
 * onde competiria por atenção com os dados.
 *
 * `<img>` cru em vez de `next/image`: o arquivo é um PNG de 7KB já recortado e
 * servido a 16px, então o otimizador não tem o que otimizar — só adiciona um
 * round-trip que pode falhar.
 */
export function BrandSignature({ className }: BrandSignatureProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-[0.4375rem] text-[0.6875rem] text-muted-foreground opacity-60 transition-opacity duration-200 hover:opacity-100',
        className,
      )}
    >
      <span className="tracking-[0.02em]">Desenvolvido por</span>
      <span className="inline-flex items-center gap-1.5">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/logo-dstorres-icon.png"
          alt=""
          width={16}
          height={16}
          className="size-4 shrink-0 object-contain"
        />
        <span className="font-semibold tracking-[0.01em] text-foreground">
          DsTorres Tecnologia
        </span>
      </span>
    </div>
  )
}
